module.exports = __webpack_public_path__ + "img/share-bg-5.8dee396d.jpg";